module.exports = __webpack_public_path__ + "img/error-dark.19be2c46.svg";